<template>
    <transition name="fade">
        <div class="loading-overlay">
            <LogoFrameIcon
                class="loading-overlay__logo-frame"
                color="#13365e"
                fill-color="#e7ebef"
            />

            <div class="loading-overlay__pattern topography-background" />

            <div class="loading-overlay__time">
                <span>{{ time }}</span>
            </div>

            <div class="loading-overlay__logo">
                <WhitelabledLogo v-if="isWhitelabled" width="360" height="90" />

                <template v-else>
                    <LogoAxRoadIcon
                        v-if="isAxRoad"
                        width="360"
                        height="90"
                        animated
                    />
                    <LogoIcon v-else width="360" height="90" animated />
                </template>

                <div>{{ $t('hint') }}</div>
                <BaseButton
                    v-if="showLogoutButton"
                    size="small"
                    class="loading-overlay__logout-button"
                    @click="handleLogout"
                    >{{ $t('logout') }}</BaseButton
                >
            </div>
        </div>
    </transition>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import LogoFrameIcon from '@/components/icons/LogoFrameIcon'
import LogoIcon from '@/components/icons/LogoIcon'
import WhitelabledLogo from '@/components/WhitelabledLogo'
import Whitelabling from '@/mixins/Whitelabling'
import LogoAxRoadIcon from '@/components/icons/LogoAxRoadIcon.vue'
import BaseButton from '@/components/redesigned/BaseButton.vue'

export default {
    name: 'LoadingOverlay',
    components: {
        LogoAxRoadIcon,
        LogoFrameIcon,
        LogoIcon,
        WhitelabledLogo,
        BaseButton,
    },
    mixins: [Whitelabling],
    data() {
        return {
            time: '',
            showLogoutButton: false,
            showLogoutTimeout: null,
        }
    },
    computed: {
        ...mapGetters('auth', ['isAxRoad']),
    },
    mounted() {
        moment.locale(this.$i18n.locale)
        this.time = moment()
            .format('LLLL')
            .replace(/\d{4}/, '$&\n')
        this.showLogoutTimeout = setTimeout(() => {
            this.showLogoutButton = true
        }, 30_000)
    },
    beforeDestroy() {
        clearTimeout(this.showLogoutTimeout)
    },
    methods: {
        handleLogout() {
            this.$store.dispatch('auth/logout')
            this.$router.push('/login', () => {
                this.$router.go()
            })
        },
    },
}
</script>

<i18n>
{
    "en": {
        "hint": "Devices are loaded ...",
        "logout": "Back to login"
    },
    "de": {
        "hint": "Geräte werden geladen ...",
        "logout": "Zurück zum Login"
    },
    "fr": {
        "hint": "Les appareils sont chargés ...",
        "logout": "Retour à la connexion"
    },
    "it": {
        "hint": "I dispositivi sono caricati ...",
        "logout": "Torna al login"
    }
}
</i18n>

<style lang="scss" scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: $color-gray-light-new;
    font-family: 'IBM Plex Mono';
    font-size: 18px;
    letter-spacing: -0.05em;
    color: rgba($color-primary, 0.5);

    &__logo {
        position: absolute;
        top: 50%;
        left: 50%;
        text-align: center;
        transform: translate(-50%, -50%);
    }

    &__logo-frame {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: 0.2;
    }

    &__time {
        position: absolute;
        top: 48px;
        right: 48px;
        text-align: right;

        span {
            white-space: pre-line;
        }
    }

    &__pattern {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    &__logout-button {
        margin-top: 16px;
    }

    @include respond-to('for-mobile-down') {
        &__time {
            top: 16px;
            right: 16px;
        }
    }
}

.fade {
    &-enter-active,
    &-leave-active {
        transition: opacity 0.2s ease-out;
    }

    &-enter,
    &-leave-to {
        opacity: 0;
    }
}
</style>
